import styled from "styled-components";
import { COLORS } from "../../styles/constants.style";

export const MuiAlertWrapper = styled.div`
  .MuiPaper-root {
    padding: 0px;
    border-radius: 8px;
  }
  /* warning background and border */
  .MuiAlert-outlinedWarning {
    background-color: ${COLORS.cirrus_orange_light};
    border-color: ${COLORS.cirrus_orange_dark};
  }
  /* error background and border */
  .MuiAlert-outlinedError {
    border-color: ${COLORS.cirrus_red_mild2};
    background-color: ${COLORS.cirrus_red_error};
  }
  .MuiAlert-message {
    width: 100%;
    padding: 16px;
  }

  .alert-box {
    display: flex;
    align-items: center;

    .alert-message-container {
      flex: 1;
      display: flex;
      padding-right: 24px;

      .alert-title {
        flex: none;
        color: ${COLORS.cirrus_black};
        margin-right: 4px;
      }
      .message {
        line-height: 1.2;
        color: ${COLORS.cirrus_black};
        word-break: normal;
      }
    }
    .MuiButtonBase-root {
      padding: 0px;
      .MuiSvgIcon-root {
        fill: ${COLORS.primary_light_blue};
      }
    }
  }
`;
